(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/registrate/player-registrate.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/registrate/player-registrate.js');

'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  loginType,
  route
} = svs.playerLoginReact.constants;

const PlayerRegistrate = _ref => {
  let {
    isBankId,
    isHome = false
  } = _ref;
  const history = useHistory();
  const lastPlayerLoginType = ReactRedux.useSelector(state => state.playerloginreact.lastPlayerLoginType);
  if (isHome && lastPlayerLoginType === loginType.BANKID || !isHome && isBankId) {
    history.push(route.REGISTRATE_BANKID_START_ROUTE);
  } else {
    history.push(route.REGISTRATE_FREJAEID_POLL_ROUTE);
  }
  return null;
};
PlayerRegistrate.propTypes = {
  isBankId: PropTypes.bool.isRequired,
  isHome: PropTypes.bool
};
svs.playerLoginReact.registrate.PlayerRegistrate = PlayerRegistrate;

 })(window);